import React, {useContext} from 'react';
import { Grid } from '@mui/material';
import { ReactComponent as Martinique} from '../../assets/martinique.svg';
import { ReactComponent as Guadeloupe} from '../../assets/guadeloupe.svg';
import { ReactComponent as Guyane} from '../../assets/guyane.svg';
import RegionCard from '../ui/RegionCard';
import { Context } from '../../App';

const RegionsSection = () => {
  const { setRegion, regions } = useContext(Context);
  const regionsCardProps = regions.map(region => ({
    icon: region.nom.toLowerCase() === 'martinique' ? <Martinique style={{ width: '100px', height:'100px', color: 'primary.main' }} /> :
      region.nom.toLowerCase() ===  'guadeloupe' ? <Guadeloupe style={{ width: '100px', height:'100px', color: 'primary.main' }} /> :
      region.nom.toLowerCase() === 'guyane' ? <Guyane style={{ width: '100px', height:'100px', color: 'primary.main' }} /> : null,
    title: region.nom,
    num: region.num,
  }));

  const handleCardClick = (regNum) => {
    setRegion(regNum);
    localStorage.setItem('region', regNum);
    window.location.href = '/'; // Redirection vers la page d'accueil
  };

  return (
    <Grid container spacing={3} sx={{ mb: 6, mt: 6, justifyContent: 'center' }}>
      {regionsCardProps.map((region, index) => (
        <Grid size={{xs: 12, sm:6, md:3}} key={index}>
          <RegionCard
            icon={region.icon}
            title={region.title}
            onClick={() => handleCardClick(region.num)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default RegionsSection;